export default "__VITE_ASSET__Dx3zD68A__"